<div class="therapy-match" *ngIf="therapies && therapies.length">
    Therapy Match


<div class="results-pane-value" style="padding: 0.5rem; padding-left: 3.42rem;" *ngIf="noTherapiesMessage">
{{ noTherapiesMessage}}
</div>

<section class="therapy">
    <div *ngFor="let therapy of therapies; let last=last" class="Marginbox__t-small flexbox">
        <div class="Flexbox item">
            
            <div class="left-content" style="flex: 2">

                <div class="therapy-biomarker Flexbox">

                    <div class="flexbox flexbox__direction-rows">
                        <div class="Flexbox">
                            <span class="gene">Gene</span>
                        </div>
                        <div class="Flexbox">
                            <span class="pointer btn-link"
                                (click)="openGeneRole(therapy.gene)">{{therapy.gene.name}}
                            </span>
                        </div>
                    </div>

                    <div class="Flexbox Spacebox__l-medium" *ngIf="therapy.codingSeqChange">
                        <div class="Flexbox Flexbox__direction-rows">
                            <div>
                                <span class="gene">Sequence Change</span>
                            </div>
                            <div class="Flexbox">
                                <span class="pointer btn-link"
                                    (click)="openAberrationEffect(therapy.effect)">{{therapy.codingSeqChange}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="Flexbox Spacebox__l-medium" *ngIf="therapy.alteration">
                        <div class="flexbox flexbox__direction-rows">
                            <div class="Flexbox">
                                <span class="gene">Aberration</span>
                            </div>
                            <div class="Flexbox">
                                <span class="pointer btn-link"
                                    (click)="openAberrationEffect(therapy.effect)">{{ therapy.alteration}}</span>
                            </div>
                        </div>
                    </div>

                    <div class="Flexbox Spacebox__l-medium">
                        <div class="flexbox flexbox__direction-rows">
                            <gen-therapy-tier
                                [tier]="therapy.tier"
                                [therapeuticQualifier]="therapy.therapeuticQualifier">
                            </gen-therapy-tier>
                        </div>
                    </div>
                </div>

                <div class="Spacebox__t-medium Flexbox Flexbox__direction-rows fs6">
                    <div class="Flexbox">
                        <span style="color: #848484;">FDA approved therapies within indication</span>
                    </div>
                    <div class="Flexbox FDA">
                        <ng-container *ngIf="therapy.drugs.length > 0">
                            <div class="therapy-relevant_drugs Flexbox"
                                *ngFor="let drug of fda_approved(therapy.drugs)">
                                <span class="drug" *ngIf="!last">{{drug.displayName}}, </span>
                                <span class="drug" *ngIf="last">{{drug.displayName}}</span>
                            </div>
                        </ng-container>
                        <span *ngIf="therapy.drugs?.length == 0 || filteredFdaApproved?.length == 0" class="drug">
                            No available data
                        </span>
                    </div>
                </div>

                <div class="Spacebox__t-medium Flexbox Flexbox__direction-rows fs6">
                    <div class="Flexbox">
                        <span style="color: #848484;">FDA approved therapies outside this indication</span>
                    </div>
                    <div class="Flexbox FDA">
                        <ng-container *ngIf="therapy.drugs.length > 0">
                            <div class="therapy-relevant_drugs Flexbox"
                                *ngFor="let drug of fda_approved_outside(therapy.drugs); let last=last">
                                <span class="drug" *ngIf="!last" genTooltip
                                [tooltipText]="showDrugIndication(drug)"
                                [tooltipPosition]="'BOTTOM'"
                                [tooltipShow]="true">{{drug.displayName}}, </span>
                                <span class="drug" *ngIf="last" genTooltip
                                [tooltipText]="showDrugIndication(drug)"
                                [tooltipPosition]="'BOTTOM'"
                                [tooltipShow]="true">{{drug.displayName}}</span>
                            </div>
                        </ng-container>
                        <span *ngIf="therapy.drugs.length == 0 || filteredFdaApprovedOutside?.length == 0" class="drug">
                            No available data
                        </span>
                    </div>
                </div>

                <div class="Spacebox__t-medium Flexbox Flexbox__direction-rows fs6">
                    <div class="Flexbox">
                        <span style="color: #848484;">Investigational therapies within indication</span>
                    </div>
                    <div class="Flexbox FDA">
                        <ng-container *ngIf="therapy.drugs.length > 0">
                            <div class="therapy-relevant_drugs Flexbox"
                                *ngFor="let drug of fda_not_approved(therapy.drugs); let last=last">
                            <span class="drug" *ngIf="!last" genTooltip
                            [tooltipText]="showStatusIndication(drug)"
                            [tooltipPosition]="'BOTTOM'"
                            [tooltipShow]="true">{{drug.displayName}}, </span>
                            <span class="drug" *ngIf="last" genTooltip
                            [tooltipText]="showStatusIndication(drug)"
                            [tooltipPosition]="'BOTTOM'"
                            [tooltipShow]="true">{{drug.displayName}}</span>
                            </div>
                        </ng-container>
                        <span *ngIf="therapy.drugs.length == 0 || filteredFdaNotApproved?.length == 0" class="drug">
                            No available data
                        </span>
                    </div>
                </div>

                <div class="Spacebox__t-medium Flexbox Flexbox__direction-rows fs6">
                    <div class="Flexbox">
                        <span style="color: #848484;">Resistance and Interactions</span>
                    </div>
                    <div class="Flexbox FDA">
                        <span *ngIf="therapy.drugResistance.length > 0" class="drug">
                            {{therapy.drugResistance}}
                        </span>
                        <span *ngIf="therapy.drugInteractions?.length > 0" class="drug">
                            Interactions:
                        </span>
                        
                        <div *ngFor="let interaction of therapy.drugInteractions; let last=last" class="drug">
                            {{interaction}}
                            <span *ngIf="!last" class="guideline Spacebox__l-tiny">{{interaction.text}}, </span>
                            <span *ngIf="last" class="guideline Spacebox__l-tiny">{{interaction.text}}</span>
                        </div>
                        <span *ngIf="(therapy.drugResistance?.length == 0 && therapy.drugInteractions?.length == 0) ||
                                (therapy.drugResistance?.length == null && therapy.drugInteractions?.length == null) ||
                                (therapy.drugResistance?.length == 0 && therapy.drugInteractions == null) ||
                                (therapy.drugResistance == null && therapy.drugInteractions?.length == 0)"
                            class="drug">
                            No available data
                        </span>
                    </div>
                </div>

                <div class="guidelines Spacebox__t-small therapy-guidelines Flexbox Flexbox__direction-rows fs6">
                    <div class="Flexbox">
                        <span style="color: #848484;">Guidelines</span>
                    </div>
                    <ng-container *ngFor="let guideline of therapy.guidlines; let last=last">
                        <div class="Flexbox" *ngIf="therapy.guidlines?.length>0">
                            <span *ngIf="!last" class="guideline">{{guideline.text}},</span>
                            <span *ngIf="last" class="guideline">{{guideline.text}}</span>
                        </div>
                    </ng-container>
                    <span *ngIf="!therapy.guidlines || therapy.guidlines?.length == 0" class="guideline">
                        No available data
                    </span>
                </div>

                <div class="therapy-therapeutic_relevance fs6">
                    <span class="pointer btn btn-link Spacebox__flat-l" (click)="openTherapeuticRelevance(therapy)"
                        style="font-size:1.28rem;">Detailed therapeutic relevance</span>
                </div>

            </div>

            <div class="content-delimiter"></div>

            <div class="right-content flexbox flexbox__direction-rows">
                <div class="treatment-approach">
                    <span class="treatment-approach-caption">Treatment approach</span>
                </div>
                <div class="treatment-approach-content" *ngIf="therapy.treatmentApproach">
                    {{therapy.treatmentApproach}}
                </div>
                <div class="treatment-approach-content" *ngIf="!therapy.treatmentApproach">
                    No available data
                </div>
            </div>

        </div>
    </div>
</section>

<label  class="therapy_content_provider" *ngIf="provider">{{ provider}}</label>
</div>